import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import config from "../config/config";
import config from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiList } from "react-icons/fi";
import { AiOutlineDashboard } from "react-icons/ai";
import { AiOutlineSetting } from "react-icons/ai";
import { TfiGallery } from "react-icons/tfi";
import { PiCertificate } from "react-icons/pi";
import { GoArrowSwitch } from "react-icons/go";
import { MdOutlineSubscriptions } from "react-icons/md";
import { FaBars } from "react-icons/fa6";
// import "../Pages/css/mobileappsidebar.css";

const Mobileappsidebar = () => {
    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <div className="mobilesidebar">

                <Button variant="togglebtn" onClick={handleShow} className="">
                    <span><FaBars className="toggleicon" /></span>
                </Button>


                <Offcanvas show={show} onHide={handleClose}>
                    <div className="mobileviewcontent">
                        <Offcanvas.Header closeButton className="border-0">
                            <Offcanvas.Title className="">
                                <span><img src='assets/images/logo/logo.svg' className='mainlogo' alt='mainlogo' style={{ width: '150px' }} /></span>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div>
                                <ul className="me-auto">
                                    <li className="active">
                                        <Link to={`${config.Exchange}`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/homeIcon.svg"
                                                    width=""
                                                    alt="bitcoin-card"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="">
                                        <Link to={`${config.LaunchApp}swap`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/swapIcon.svg"
                                                    width=""
                                                    alt="swapIcon"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Swap
                                        </Link>
                                    </li>

                                    <li className="">
                                        <Link to={`${config.LaunchApp}simplestaking`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/stackingIcon.svg"
                                                    width=""
                                                    alt="stackingIcon"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Staking
                                        </Link>
                                    </li>

                                    <li className="">
                                        <Link to={`${config.LaunchApp}stakinghistory`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/stackingIcon.svg"
                                                    width=""
                                                    alt="stackingIcon"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Stacking History
                                        </Link>
                                    </li>

                                    <li className="">
                                        <Link to={`${config.LaunchApp}transactionhistory`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/transactionIcon.svg"
                                                    width=""
                                                    alt="transactionIcon"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Transactions
                                        </Link>
                                    </li>

                                    <li className="">
                                        <Link to={`${config.baseUrl}`} className="nav-link ">
                                            <span>
                                                <img
                                                    src="assets/icons/logoutIcon.svg"
                                                    width=""
                                                    alt="logoutIcon"
                                                    className="sidemenuIcon"
                                                />
                                            </span>
                                            Log out
                                        </Link>
                                    </li>

                                    {/* <li>
                                        <div className="logoutbox">
                                            <ul className="">
                                                <li className="">
                                                    <Link to={`${config.baseUrl}`} className="nav-link ">
                                                        <span>
                                                            <img
                                                                src="assets/icons/logoutIcon.svg"
                                                                width=""
                                                                alt="logoutIcon"
                                                                className="sidemenuIcon"
                                                            />
                                                        </span>
                                                        Log out
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li> */}
                                </ul>



                            </div>
                        </Offcanvas.Body>
                    </div>
                </Offcanvas>

            </div>
        </>
    )
}

export default Mobileappsidebar;
